module.exports = __webpack_public_path__ + "4e4aa3bd06b5cddd4c7ee2d2e931cc46.png";